/** @generated env=product api=https://www.webloom.cn generatedAt=2026-09-15T10:14:04.806Z */
/** 活动详情简洁路由：contestId、seasonId 配置在 meta，复用 game-data 组件 */
/** 仅由对应环境的 update-activity-short 更新，webpack 按打包环境只编入本文件 */
const gameDataMeta = {
  IndexHeader: true,
  itemIndex: 1,
  needScroll: true
}

export default [
  {
    path: '/GCEP',
    name: 'GCEP',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1836884756814471168',
      seasonId: '1858319691983056896'
    }
  },
  {
    path: '/CNEC',
    name: 'CNEC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1017697392442650626',
      seasonId: '1889863159167283200'
    }
  },
  {
    path: '/BioGenius-X',
    name: 'BioGenius-X',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1728888799716667392',
      seasonId: '1852901662600048640'
    }
  },
  {
    path: '/iHOSA',
    name: 'iHOSA',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '908868162978848767',
      seasonId: '1890859756151746560'
    }
  },
  {
    path: '/CBPA',
    name: 'CBPA',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1127419795642359808',
      seasonId: '1890966162771124224'
    }
  },
  {
    path: '/ESB',
    name: 'ESB',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1365056780450922496',
      seasonId: '1901112973288767488'
    }
  },
  {
    path: '/SIC',
    name: 'SIC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '908868162978848768',
      seasonId: '1917700513105817600'
    }
  },
  {
    path: '/CNAD',
    name: 'CNAD',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1652123740634460160',
      seasonId: '1916679731730821120'
    }
  },
  {
    path: '/CNAP',
    name: 'CNAP',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1652124047502442496',
      seasonId: '1916680397958381568'
    }
  },
  {
    path: '/CNAT',
    name: 'CNAT',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1652124208219779072',
      seasonId: '1785845266902003712'
    }
  },
  {
    path: '/CAQT',
    name: 'CAQT',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1166810017144320000',
      seasonId: '1655014207462273024'
    }
  },
  {
    path: '/WYF-FLALS',
    name: 'WYF-FLALS',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1753169152111124480',
      seasonId: '1864626457033154560'
    }
  },
  {
    path: '/NSL',
    name: 'NSL',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1017697405835063297',
      seasonId: '1916243107268108288'
    }
  },
  {
    path: '/CNCC',
    name: 'CNCC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1322628364858654720',
      seasonId: '1911537411448479744'
    }
  },
  {
    path: '/WYF-FELS-UK',
    name: 'WYF-FELS-UK',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1885061005764042752',
      seasonId: '1885173350532349952'
    }
  },
  {
    path: '/MICOS',
    name: 'MICOS',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1845259483060740096',
      seasonId: '1857524838869204992'
    }
  },
  {
    path: '/BSSD',
    name: 'BSSD',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1874929181238861824',
      seasonId: '1874951565698244608'
    }
  },
  {
    path: '/SIC-Summit',
    name: 'SIC-Summit',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1590900340201582592',
      seasonId: '1656779888734208000'
    }
  },
  {
    path: '/WYF-FELS-ASIA',
    name: 'WYF-FELS-ASIA',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1613655096896262144',
      seasonId: '1859778628116656128'
    }
  },
  {
    path: '/CYEY',
    name: 'CYEY',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1922751171508940800',
      seasonId: '1922766344978280448'
    }
  },
  {
    path: '/EWCC',
    name: 'EWCC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1922742933807923200',
      seasonId: '1922859084672102400'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/activity-short.product.js